import { parseAnalyzerResultArray } from 'utility/textAnalyzer.util'

export { parseAnalyzerResultArray }

export const normalizeIcd10 = (data) =>
  parseAnalyzerResultArray(data)
    .map((item) =>
      item && typeof item === 'object'
        ? {
            code: item.code || item.icd10Code || item.icd10 || '',
            nameEn: item.name_en || item.nameEn || item.name || '',
            nameTh: item.name_th || item.nameTh || item.thaiName || '',
          }
        : { code: '', nameEn: '', nameTh: '' },
    )
    .filter((item) => item.code)

export const normalizeOrderItems = (data) =>
  parseAnalyzerResultArray(data).map((item) => {
    if (!item || typeof item !== 'object') {
      return { code: '', name: String(item || ''), source: '', raw: item }
    }
    const code =
      item.code ||
      item.drugItemCode ||
      item.itemCode ||
      item.labCode ||
      item.radiologyCode ||
      ''
    const name =
      item.name ||
      item.drugItemName ||
      item.itemName ||
      item.labName ||
      item.radiologyName ||
      item.thaiName ||
      ''
    return { code, name, source: item.source || '', raw: item }
  })

export const extractDiagnoses = (analyzed) => {
  const formData = analyzed && analyzed.formData ? analyzed.formData : {}
  const diagnoses = []
  const suggestions = Array.isArray(formData.diagnosisSuggestions)
    ? formData.diagnosisSuggestions
    : []
  suggestions.forEach((entry) => {
    const text =
      entry && typeof entry === 'object'
        ? entry.diagnosis
        : typeof entry === 'string'
        ? entry
        : ''
    if (text) diagnoses.push(text)
  })
  ;[formData.provisionalDiagnosis, formData.differentialDiagnosis].forEach(
    (field) => {
      if (typeof field === 'string') {
        field.split(/[,;\n]/).forEach((part) => diagnoses.push(part))
      }
    },
  )
  return Array.from(
    new Set(diagnoses.map((text) => String(text || '').trim()).filter(Boolean)),
  )
}

export const buildOrderText = (analyzed) => {
  const turns = analyzed && Array.isArray(analyzed.turns) ? analyzed.turns : []
  return turns
    .map((turn) => (turn && turn.text ? String(turn.text).trim() : ''))
    .filter(Boolean)
    .join('\n')
}
